<template>
  <v-dialog
    v-model="dialog"
    width="632px">
    <div class="dialog-container">
      <span class="title">Underwriting Questions</span>
      <div class="p-class">
        <template v-if="isFina">
          <span class="bold">You are assisting a 3rd party to pre-fill information in
            <span class="width-20">
              <v-select
                v-model="cust_typ"
                :disabled="disabledType||isCopy"
                :list="userTypeOptions"></v-select></span>
          </span>
          <span class="bold">capacity</span>
        </template>
        <span
          v-else
          class="bold"> Please select if the customer meets all the following requirements </span>
        <v-checkbox-group
          v-model="underwriting"
          :block="true"
          :list="underList" >
          <template #default="{ item }">
            <span :class="{'special-waring':item.type=='clause'}">{{item.name}}</span>
          </template>
        </v-checkbox-group>
        <div
          v-for="(item,index) in showUnderList"
          :key="'clause'+index">
          <el-checkbox
            v-model="select"
            disabled>
            <template>
              <span :class="{'special-waring':item.type=='clause'}">{{item.name}}</span>
            </template>
          </el-checkbox>
        </div>
      </div>

      <!--      <v-checkbox-group-->
      <!--        v-model="underwriting"-->
      <!--        :block="true"-->
      <!--        disabled-->
      <!--        :list="showUnderList" >-->
      <!--        <template #default="{ item }">-->
      <!--          <span :class="{'special-waring':item.type=='clause'}">{{item.name}}</span>-->
      <!--        </template>-->
      <!--      </v-checkbox-group>-->

      <div class="flex-sb">
        <div>
          <v-button @click="dialog = false">Cancel</v-button>
        </div>
        <div>
          <v-button
            type="primary"
            @click="handlerConfirm">Confirm</v-button>
        </div>
      </div>
    </div>
  </v-dialog>
</template>
<script>
import MixinOptions from '@/mixins/options'
import {onlyPersonalProductId,onlyCompanyProductId} from '@/utils/product'
import {mapActions, mapState} from 'vuex'
export default {
  name: 'BuyPolicyTipsDialog',
  mixins: [MixinOptions],
  props: {
    classId: {
      type: [String, Number],
      default: 14
    },
    underList:{
      type:Array,
      default:()=>([])
    },
    showUnderList:{
      type:Array,
      default:()=>([])
    },
    isCopy:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      cust_typ:'',
      dialog: false,
      underwriting: [],
      select:true,
      onlyPersonal:[...onlyPersonalProductId],
      onlyCompany:[...onlyCompanyProductId],
    }
  },
  computed: {
    ...mapState('account', ['customerId']),
    ...mapState('quote', ['copyQuoteForm', 'quoteForm']),
    isFina() {
      let path = this.$route.path
      return path.includes('/fina/')
    },
    localAllOptions() {
      if (this.classId === 14) {
        return this.allOptions
      } else {
        return this[`allOptions${this.classId}`] || {}
      }
    },
    disabledType() {
      const productId = Number(this.productId)
      if (this.customerId || this.classId == 12) return true
      if (this.onlyPersonal.includes(productId)) return true
      if(this.onlyCompany.includes(productId)) return true
      return false
    },
    isCommercial(){
      return this.classId== 12
    }
  },
  watch: {
    underList: {
      immediate: true,
      deep: true,
      handler(val, old) {
        if (val && val.length > 0) {
          let arr = []
          val.some(item => {
            const {id} = item
            arr.push(id)
          })
          this.underwriting = arr
        }
      }
    },
    classId: {
      immediate: true,
      handler(val) {
        if (val == 12) {
          let {cust_typ} = this.quoteForm || {}
          this.cust_typ = cust_typ
        }
      }
    }
  },
  mounted() {
    if(this.isFina){
      if(this.onlyPersonal.includes(Number(this.productId))) {
        this.cust_typ = 1
      }
      else if(this.onlyCompany.includes(Number(this.productId))) {
        this.cust_typ = 2
      }
      else this.cust_typ = 1

      if(this.isCommercial){
        const {cust_typ} = this.quoteForm
        this.cust_typ = cust_typ
      }
      if(this.isCopy){
        let {cust_typ} = this.copyQuoteForm
        this.cust_typ = cust_typ
      }
    }

  },
  methods: {
    changeDialog() {
      this.dialog = !this.dialog
    },
    handlerConfirm() {
      // 處理問題， 檢查是否全選
      const { underwriting = [] } = this.localAllOptions
      const options = JSON.parse(JSON.stringify(this.underList))
      const value = this.underwriting
      if(options.length === value.length) {
        this.dialog = false
        this.$emit('confirm','',this.customerId||!this.isFina?'':this.cust_typ)
      }
      else {
        // 整合數據
        const underwriting = options.reduce((result, item) => {
          const { id } = item
          let answer = 0
          if(value.includes(id)) {
            answer = 1
          }
          result.push({
            ...item,
            answer
          })
          return result
        }, [])
        this.dialog = false
        this.$emit('confirm', underwriting,this.customerId||!this.isFina?'':this.cust_typ)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
    .dialog-container {
      padding: 15px;
      font-size: 16px;
      color: #616266;
      .bold {
          font-weight: bold;
        display: flex!important;
        align-items: center;
      }
      .p-class {
          padding: 10px 0;
          span {
              display: block;
              padding-bottom: 10px;
              word-break: break-word;
          }
      }
      .special-waring{
        color: #d73a49;
      }
    }
    .width-20{
      width: 150px;
      font-weight: 400;
      padding-bottom: 0px!important;
      margin-left: 10px;
    }
</style>
